import { Loadable } from '@/components/loaders';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetDistributionChannelConnectorsQuery } from '@/services/endpoints/distributionChannels';
import { FC } from 'react';
import { DataDestinationsGrid } from './DataDestinationsGrid';

export const DestinationSection: FC = () => {
  const { id: workspaceId } = useWorkspace();
  const { data, isLoading } = useGetDistributionChannelConnectorsQuery({ workspaceId });
 
  return (
      <Loadable isLoading={isLoading}>
        <DataDestinationsGrid dataDestinations={data} />
      </Loadable>
    );
};
